import { Box, styled } from '@mui/material';
import androidImage from '../../assets/img/android_bg.png';


export const StyledBox = styled(Box)(({ theme }) => ({
    backgroundImage: `url(${androidImage})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center',
    height: '200px', 
    width: '500px', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }));

export default StyledBox;